import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IMapFilterState {
    apartment: number | null;
    districtId: number | null;
    price: number | null;
}

export type FilterDataKeys = keyof IMapFilterState;

type UpdateFilterPayload = {
    key: FilterDataKeys;
    value: IMapFilterState[FilterDataKeys];
};

const initialState: IMapFilterState = {
    apartment: null,
    districtId: null,
    price: null,
};

const mapFilterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        updateFilterData(
            state: IMapFilterState,
            action: PayloadAction<UpdateFilterPayload>
        ) {
            const { key, value } = action.payload;

            switch (key) {
                case "price":
                    state.price = value as number | null;
                    break;
                case "apartment":
                    state.apartment = value as number | null;
                    break;
                case "districtId":
                    state.districtId = value as number | null;
                    break;
            }
        },
        resetFilterData(state: IMapFilterState) {
            state.apartment = null;
            state.districtId = null;
            state.price = null;
        }
    },
});

export const { updateFilterData, resetFilterData } = mapFilterSlice.actions;
export default mapFilterSlice.reducer;
